import { render } from "./StudentDisciplineDataTable.vue?vue&type=template&id=bc6e97fc&scoped=true"
import script from "./StudentDisciplineDataTable.vue?vue&type=script&lang=js"
export * from "./StudentDisciplineDataTable.vue?vue&type=script&lang=js"

import "./StudentDisciplineDataTable.vue?vue&type=style&index=0&id=bc6e97fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6e97fc"]])

export default __exports__